module.exports = __webpack_public_path__ + "static/media/app-logo.e82b861f.svg";